var map = {
	"./en-US/Products-Import-Framework.csv": 74560,
	"./en-US/Products-Import-Framework.xlsx": 66279,
	"./esp/Modelo-Importacion-Productos.csv": 20750,
	"./esp/Modelo-Importacion-Productos.xlsx": 80890,
	"./pt-BR/Modelo-Importacao-Produtos.csv": 47713,
	"./pt-BR/Modelo-Importacao-Produtos.xlsx": 70804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4956;